const toastStyle = {
  SUCCESS: "toast-success",
  ERROR: "toast-error",
  WARNING: "toast-warning",
  INFO: "toast-info",
};

const getToastStyle = (toastType) => {
  return toastStyle[toastType];
};

export { getToastStyle };
